import { formatDate } from "./../CaseDetailUtils";
export const labelResolver = (key, formId) => {
  const map = {
    "9142B": {
      registrationNumber: "Registration Number",
      createdDate: "Created Date",
      empBusinessName: "Employer Name",
      jobTitle: "Job Title",
      jobMsa: "Job MSA",
      numberOfWorkers: "Number of Workers",
      validityStartDate: "Valid From",
      validityEndDate: "Valid To",
      status: "Status",
      originatingCaseNumber: "Originating Case Number",
      socCode: "SOC Code",
      socTitle: "SOC Title",
      tempneedDescription: "Temp Need Description",
      tempneedNature: "Temp Need Nature",
      tempneedStart: "Registered Start Date of Need",
      tempneedEnd: "Registered End Date of Need",
      empFein: "FEIN",
      linkedCases: "Linked Cases",
    },
    formId2: {
      // Define label mappings for formId2 here
    },
  };
  return map[formId][key];
};

export const valueResolver = (key, data, formId) => {
  const map = {
    "9142B": {
      tempneedStart: (data) => formatDate(data, "UTC"),
      tempneedEnd: (data) => formatDate(data, "UTC"),
      validityStartDate: (data) => formatDate(data, "UTC"),
      validityEndDate: (data) => formatDate(data, "UTC"),
    },
  };
  return map[formId][key] ? map[formId][key](data) : data;
};
